<swiper [config]="config" [spaceBetween]="remToPixels(1)" (swiper)="onSwiper($event)" (slideChange)="onSlideChange()" class="w-full flex flex-col-reverse">
    <ng-content></ng-content>
</swiper>
